(ns common.schema.entities.counterparty-diligence.templates.demo.natural-person
  (:require
   [common.schema.entities.counterparty-diligence.templates.questions.person :as person-q]
   [common.schema.entities.counterparty-diligence.templates.questions.common :as common-q]
   [clojure.string :as string]
   [potpuri.core :as p]))

(def template-id :counterparty-diligence-template/demo-natural-person)

(def yes-no-options
  [{:value :yes
    :label "Yes"}
   {:value :no
    :label "No"}])

(defn find-person
  "Extract person data from natural person template answers for screening."
  [{:keys [data]}]
  (let [{:keys [person/first-name person/last-name
                person/date-of-birth person/nationality person/country]} data
        first-name (-> first-name str string/trim)
        last-name (-> last-name str string/trim)
        country (or nationality country)]
    (when (and (seq first-name) (seq last-name))
      {:first-name    first-name
       :last-name     last-name
       :date-of-birth date-of-birth
       :country       country})))

(def schema
  {:template/id template-id
   :template/template-name "Natural Person"
   :template/find-person find-person
   :template/form-title    {:en "Transaction Counterparty KYC Check"}
   :template/form-preface
   {:en (str "<p>In accordance with Anti-Money Laundering (AML) and Counter Terrorist Financing (CTF) regulations, "
             "We are required to collect specific Know Your Customer (KYC) information for all counterparties involved in a transaction. "
             "As part of legal due diligence, a nominated counsel is requested to gather and review the following documentation on the seller, "
             "purchaser and target company and report any suspicious remarks to us.</p>"
             "<br/>"
             "<p>Please fill in the information and attach all reviewed materials to this online form.</p>")}

   :template/schema
   (merge
    (->> [person-q/first-name
          person-q/last-name
          person-q/nationality
          person-q/national-identification-number
          person-q/date-of-birth
          person-q/proof-of-address-attachment
          person-q/source-of-funds-and-wealth
          person-q/type-of-identification-attachment
          person-q/identification-expiration-date]
         (p/index-by :field))

    {(:field person-q/passport-photo-page-file)
     (merge
      person-q/passport-photo-page-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/passport)))})}

    {(:field person-q/id-card-front-file)
     (merge
      person-q/id-card-front-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})}

    {(:field person-q/id-card-back-file)
     (merge
      person-q/id-card-back-file
      {:visibility-fn (fn [{:keys [data]}]
                        (-> data
                            :person/type-of-identification-attachment
                            (= :identification.type/id-card)))})}

    {:person-is-politically-exposed
     {:label {:en "Is the person politically exposed?"}
      :data-type :data.type/keyword
      :options yes-no-options}
     (:field common-q/signatories) common-q/signatories})

   :template/sections
   {:basic-information
    {:ord   0
     :title {:en "Basic information"}
     :fields (->> [person-q/first-name
                   person-q/last-name
                   person-q/nationality
                   person-q/national-identification-number
                   person-q/date-of-birth
                   person-q/proof-of-address-attachment
                   person-q/source-of-funds-and-wealth]
                  (mapv :field))}

    :pep-info
    {:ord 1
     :title {:en "PEP information"}
     :fields [:person-is-politically-exposed]}

    :identification
    {:ord 2
     :title {:en "Identification"}
     :fields (->> [person-q/type-of-identification-attachment
                   person-q/identification-expiration-date
                   person-q/passport-photo-page-file
                   person-q/id-card-front-file
                   person-q/id-card-back-file]
                  (mapv :field))}

    :signatories
    {:ord                3
     :title              {:en "Signatories"}
     :info-text          {:en "After submission, a pdf document will be sent to these persons for e-sign"}
     :signatory-section? true
     :fields [(:field common-q/signatories)]}}})
